import { ORDER_DISPLAY_STATUS } from './orderDisplayStatus';
import { ORDER_DISPLAY_STATUS_TONE } from './orderDisplayStatusTone';
import { ORDER_STATUS } from './orderStatus';

// Badge tone per status — kept apart from orderStatus.js, which mappers import (CLAUDE.md); matches the detail header's.
export const ORDER_STATUS_TONE = Object.freeze({
  [ORDER_STATUS.active]: ORDER_DISPLAY_STATUS_TONE[ORDER_DISPLAY_STATUS.active],
  [ORDER_STATUS.closed]: ORDER_DISPLAY_STATUS_TONE[ORDER_DISPLAY_STATUS.closed],
  [ORDER_STATUS.cancelled]: ORDER_DISPLAY_STATUS_TONE[ORDER_DISPLAY_STATUS.cancelled],
});
